import { Box, Typography } from '@mui/material';
import React from 'react'

const Page403 = () => {
  return (
    <Box sx={{
        width :'100%',
        height : '100%',
        display : 'flex',
        flexDirection : 'column',
        justifyContent : 'center',
        alignItems : 'center',
        minHeight: '100vh',
    }}>
        <Typography variant='h2' fontWeight='600' color='primary' mb={1}>403</Typography>
        <Typography variant='h5' fontWeight={600}>We are sorry,but you do not have access to this page.</Typography>
    </Box>
  )
}

export default Page403;
